import { db } from "../../firebase/firebase";
import revealData from '../../util/revealData';
import moment from "moment";

export const getAffiliatesRequest = async (userId) => {
  try {
    let affiliates = [];
    let raw = [];
    await db.ref(`affiliates/${userId}`).once('value', snap => {
      affiliates = snap.val() ? Object.values(snap.val()) : []
    });
    if (affiliates.length > 0) {
      await affiliates.forEach(async (affiliate, index) => {
        await db.ref(`users/${affiliate.targetId}`).once('value', async snap => {
          let user = await snap.val();
          if (user.rol === 'major') {
            await db.ref(`products/${user.id}`).once('value', productsSnap => {
              raw.push({
                ...affiliate,
                userData: {
                  ...user,
                  products: productsSnap.val() ? Object.values(productsSnap.val()) : []
                },
              });
            });
          } else raw.push({ ...affiliate, userData: { ...user } });
        });
      });
    }

    return await revealData(raw);
  } catch (error) {
    return error;
  }
}

export const deleteAffiliateRequest = async (affiliatesId, targetId, userId) => {
  try {
    await db.ref(`affiliates/${targetId}/${affiliatesId}`).remove();
    await db.ref(`affiliates/${userId}/${affiliatesId}`).remove();
  } catch (error) {
    return error
  }
}

export const addAffiliateRequest = async (targetId, userId) => {
  try {
    const getCommonModule = (id) => ({
      date: moment().format("DD-MM-YYYY"),
      time: moment().format("hh:mm"),
      id
    })
    const newRef = await db.ref(`affiliates/${userId}/`).push();
    await db.ref(`affiliates/${userId}/${newRef.key}`).set({
      ...getCommonModule(newRef.key),
      userId,
      targetId,
    });
    await db.ref(`affiliates/${targetId}/${newRef.key}`).set({
      ...getCommonModule(newRef.key),
      targetId: userId,
      userId: targetId,
    });
  } catch (error) {
    return error
  }
}